import React from 'react';
import "./Footer.css";
const Footer = () => {
    return (
        <div className="container">
            <div className="d-flex justify-content-center">
                <div class="mt-2">
                    <div class="social-home-links">
                        <ul className="list-unstyled d-flex">
                            <li><a href="https://github.com/Shohelrana63" target="_blank"><i class="fa fa-github"></i></a></li>
                            <li><a href="https://www.linkedin.com/in/shohelranabaig/" target="_blank"><i class="fa fa-linkedin"></i></a></li>
                            <li><a href="https://www.facebook.com/shohelranabeg" target="_blank"><i class="fa fa-facebook"></i></a></li>
                            <li><a href="https://twitter.com/Shohelranabaig" target="_blank"><i class="fa fa-twitter"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div class="copyright">
                    <p >Designed & Built by
                    <span style={{ color: "#e9af1d" }} class="font-weight-bold"> Shohel Rana</span>  ||

                    All Rights Reserved</p>
                </div>
            </div>
            {/* <div>
                <div className="">
                    <p style={{ color: "#e9af1d" }}>Designed & Built by <script>document.write(new Date().getFullYear())</script>Shohel Rana
                    <br />
                    All Rights Reserved</p> </div>

            </div> */}
        </div>
    );
};

export default Footer;